<template>
  <div
    class="main-box"
    @click.capture="handleContainerClick"
    :style="{
      background: `url(${bg})`,
    }"
  >
    <div
      class="hidden-volume-box"
      @click.prevent="handleShowVoice"
      ref="voiceBox"
      v-show="bgm.length && !showVoice"
    >
      <img
        src="https://m.elongstatic.com/year-wish/newVoice.png"
        alt=""
        v-if="isOpenVoice"
      />
      <img
        src="https://m.elongstatic.com/year-wish/newClose.png"
        alt=""
        v-else
      />
    </div>
    <div class="volume-box" ref="voiceBox" v-show="bgm.length && showVoice">
      <img
        src="https://m.elongstatic.com/year-wish/newVoice.png"
        alt=""
        @click.stop="openVoice"
        v-if="isOpenVoice"
      />
      <img
        src="https://m.elongstatic.com/year-wish/newClose.png"
        @click.stop="openVoice"
        alt=""
        v-else
      />
      <div @click.stop style="width: 100%">
        <el-slider
          v-model="volume"
          style="width: 90%"
          :show-tooltip="false"
          ref="mySlider"
          @input="updateVolume()"
          :min="0"
          :max="100"
          class="voice-slider"
        ></el-slider>
      </div>
    </div>
    <div class="luckMain" id="content">
      <!-- <img
        src="https://m.elongstatic.com/year-wish/newTitle2.png"
        alt=""
        class="main-title"
      /> -->
      <div class="container">
        <div class="content">
          <MyAudio ref="MyAudio" :list="bgm" :autoplay="!isLoop"></MyAudio>
          <operate
            ref="operate"
            :awardList="awardList"
            :unWinParticipants="unWinParticipants.length"
            :isBegin="isBegin"
            :isLottery="isLottery"
            :controlNum="controlNum"
            :rollIdArr="rollIdArr"
            :userData="userData"
            :awardId="awardId"
            :isEnding="isEnding"
            :disabledChange="disabledChange"
            @start="onStart"
            @stop="onPuse"
            @updateNum="updateNum"
            @swiper="onSwiper"
            @getDetail="getDetail"
          />
          <div class="rewardsOrder">
            <div class="draw-title">获奖名单</div>
            <div
              class="people-box"
              ref="peopleBox"
              :style="
                rollIdArr.length <= 15
                  ? 'align-content: center;'
                  : 'align-content: flex-start'
              "
            >
              <div v-if="isLottery == 0 && isShowEmpty" class="empty-box">
                <img
                  class="empty-src"
                  src="https://m.elongstatic.com/year-wish/my-wisg-bg2.png"
                  alt=""
                />
              </div>
              <div v-else-if="isLottery == 1 && rollIdArr.length == 0" class="draw-text">
                当前奖品已开奖，请前往后台下载中奖名单
              </div>
              <div v-else class="people-item" v-for="i in rollIdArr">
                <div class="people-name">{{ i.name }}</div>
                <div class="people-code">{{ i.number }}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            class="action-title"
            @click="clickStart"
            v-if="!isBegin && !isEnding"
          >
            开始抽奖
          </div>
          <div
            class="action-title"
            :style="{
              color: isEnding ? '#980F16' : '#980F16',
              cursor: isEnding ? 'not-allowed' : 'pointer',
            }"
            @click="cliskStop"
            v-if="isBegin || isEnding"
          >
            停
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//https://pavo.elongstatic.com/i/ori/1gbwTkOGZ8c.png
//require('../assets/main1.png')
import { queryActivityDetail, qryRewardPerson } from "../service/api";
import { debounce } from "../utils/utils";
import Operate from "./components/luckdraw/operate";
import MyAudio from "./components/luckdraw/audio";
export default {
  name: "luckDraw",
  data() {
    return {
      bg: "",
      swiperOption: {
        loop: false,
        autoplay: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        speed: 1000,
      },
      rewardsInfo: {},
      awardList: [], // 该活动下的奖品数据
      userData: [], // 总用户集合
      rollIdArr: [], // 当前抽中集合
      initial: false, // 是否加载数据完成
      isForbisBegin: false, // 是否开始
      isBegin: false,
      isShowEmpty: true,
      // 滚动间隔
      intervalTime: 50,
      isForb: false,
      isAldready: false,
      oneMorea: false,
      isLottery: 0,
      oneMore: false,
      musicState: true, // 音乐播放状态
      music: {
        show: false,
      },
      boxImg:
        "https://www.apple.com.cn/iphone-14/images/overview/display/xdr_display__cxbhgrgt5keq_large.jpg",
      activityId: "",
      awardId: "",
      peopleNum: 0,
      unWinParticipants: [],
      controlNum: 0,
      isEnding: false,
      volume: 50, // 默认音量
      bgm: [],
      showVoice: false, //展示音量调节
      isOpenVoice: false, //是否开启背景音乐
      isFirst: true, //是否是第一次点击开启背景音乐的按钮
      isFirstUpload: true, //是否是首次加载完页面，如果是首次，那滑块里的显示开启声音不显示
      isLoop: 0, //是否循环播放,0循环播放，1不循环播放
      finished: false, //滚动是否触底结束
      disabledChange:false,//在滚动的时候是否禁用左右切换
    };
  },
  components: {
    Operate,
    MyAudio,
  },
  mounted() {
    var browerWidth = window.innerHeight; //浏览器可视宽度
    var baseWidth = 720; //设计稿宽度
    var zoomValue = browerWidth / baseWidth; //缩放比例计算
    console.log(browerWidth);
    console.log(zoomValue);
    // document.getElementById("content").style.height =
    //   `${window.innerHeight}PX`; //mainContainer为主容器id
    // document.getElementById("content").style.width =
    //   `${window.innerWidth}PX`; //mainContainer为主容器id
    document.getElementById(
      "content"
    ).style.transform = `scale(${zoomValue}) translate(-50%, -50%)`; //mainContainer为主容器id
    window.onresize = function () {
      console.log(innerHeight);
      //窗口尺寸变化时，重新计算和缩放
      browerWidth = window.innerHeight;
      zoomValue = browerWidth / baseWidth;
      //   document.getElementById("content").style.height =
      //   `${window.innerHeight}PX`; //mainContainer为主容器id
      // document.getElementById("content").style.width = 
      //   `${window.innerWidth}PX`; //mainContainer为主容器id
      document.getElementById(
        "content"
      ).style.transform = `scale(${zoomValue}) translate(-50%, -50%)`;
    };
    // this.$nextTick(() => {
    //   this.startScrolling();
    // })
  },
  async created() {
    const query = this.$route.query;
    if (query) {
      const { activityId, awardId } = query;
      this.activityId = activityId;
      this.awardId = awardId;
      await this.getRewards(this.activityId, this.awardId);
      this.$nextTick(()=>{
        this.isShowEmpty = this.isLottery == 1? false:true
      })
    }

    // 监听 空格键
    window.addEventListener("keydown", this.handleKeyDown, true);
    // this.getRewardsPersons();
  },
  watch: {},
  computed: {},
  methods: {
    clickStart() {
      this.$refs.operate.onStart();
    },
    cliskStop() {
      this.$refs.operate.onStop();
    },
    handleShowVoice() {
      this.showVoice = true;
    },
    handleContainerClick(event) {
      if (
        event.target === this.$refs.voiceBox ||
        event.target.closest(".volume-box")
      ) {
        // 如果点击的是目标容器内部的元素，则不做任何操作
        return;
      }
      // 隐藏目标容器和遮罩层
      this.showVoice = false;
    },

    // 滑块
    updateVolume() {
      this.$refs.MyAudio.updateVolume(this.volume);
      if (this.isFirstUpload) {
        this.isFirstUpload = false;
      } else {
        this.isOpenVoice = true;
        if (this.isFirst) {
          this.$refs.MyAudio.playCurrentAudio();
          this.isFirst = false;
        }
      }
      if (this.volume <= 0) {
        this.isOpenVoice = false;
      }
    },
    openVoice() {
      this.isOpenVoice = !this.isOpenVoice;
      if (this.isFirst) {
        this.$refs.MyAudio.playCurrentAudio();
        this.isFirst = false;
      }
      if (this.isOpenVoice) {
        this.$refs.MyAudio.updateVolume(this.volume);
      } else {
        this.$refs.MyAudio.updateVolume(0);
      }
    },
    startScrolling() {
        const scrollingDiv = this.$refs.peopleBox;
        console.log("this.finishedthis.finishedthis.finished",this.finished);
        if (this.finished) return; //滚动是否结束
        // 判断是否接近底部，可以根据实际情况调整阈值
        this.intervalId = setInterval(() => {
        const { scrollTop, scrollHeight, clientHeight } = scrollingDiv;
        // console.log('asdfasdf', scrollTop, scrollHeight, clientHeight);
        const isCloseToBottom = scrollTop + clientHeight >= scrollHeight - 10;
          scrollingDiv.scrollTop += 1; // 调整滚动速度

          // 如果滚动到底部，清除定时器
        //   console.log('qwerqwe', scrollingDiv.scrollTop, scrollingDiv.clientHeight);
          if (isCloseToBottom) {
            console.log("结束了");
            this.finished = true;
            clearInterval(this.intervalId);
            // 缓慢的回到顶部，设置个延迟回到顶部
            this.setScrollToTop = setTimeout(() => {
              this.scrollToTop();
            }, 1000);
          }
        }, 20);

        //     console.log('qwerqwe', scrollingDiv.scrollTop, scrollingDiv.clientHeight);
        //     const animateScroll = () => {
        //         scrollingDiv.scrollTop += 4; // 调整滚动速度

        //         // 如果滚动到底部，清除动画
        //         if (scrollingDiv.scrollTop + scrollingDiv.clientHeight >= scrollingDiv.scrollHeight) {
        //             console.log("结束了");
        //             this.finished = true;
        //             cancelAnimationFrame(animateScroll);
        //             // 缓慢地回到顶部
        //             this.scrollToTop();
        //         } else {
        //             // 继续下一帧动画
        //             requestAnimationFrame(animateScroll);
        //         }
        //     };

        // // 开始动画
        // animateScroll();
    },
    scrollToTop() {
        const scrollingDiv = this.$refs.peopleBox;
        this.topInterval = setInterval(() => {
          scrollingDiv.scrollTop -= 1; // 调整滚动速度
          // 如果滚动到顶部，清除定时器
          if (scrollingDiv.scrollTop == 0) {
            console.log("结束了");
            this.disabledChange = false
            clearInterval(this.topInterval);
          }
        }, 20);
    },
    endScrolling() {
      clearInterval(this.intervalId);
      clearTimeout(this.setTimeoutId);
      clearTimeout(this.setTimeoutId2);
    },
    // 轮播切换
    async onSwiper(val) {
        if(!this.disabledChange){
            this.awardId = this.awardList[val].id;
            await this.getRewards(this.activityId, this.awardId);
                this.rollIdArr = [];
                console.log("222",this.isLottery);
                this.isShowEmpty = this.isLottery == 1? false:true
        }
    },
    // 更新人数
    updateNum(val) {
      this.peopleNum = val;
    },
    // 9.切换音乐播放状态
    toggleMusic() {
      this.musicState = !this.musicState;
      if (this.music.show) {
        if (this.musicState) {
          this.$refs.music.pause();
        } else {
          this.$refs.music.play();
        }
      }
    },
    handleKeyDown(e) {
      console.log(e, "eeeeee");
      const code = e.keyCode; // 32 是空格键
      if (code === 38 || code === 40) {//上键
        this.keyUpdateVoice(code);
      }
    },
    // 键盘控制音量
    keyUpdateVoice(type){
        this.isOpenVoice = true
        if(type == 40){
            if(this.volume >0){
                this.volume = this.volume - 5
            }else{
                this.isOpenVoice = false
                this.volume = 0
            }
        }else if(type == 38){
            if(this.volume < 100){
                this.volume = this.volume + 5
            }
        }
    },
    // 绑定样式
    bindStyleOrder(type) {
      return {
        1: "boxOne",
        2: "boxTwo",
        3: "boxThree",
        4: "boxFour",
      }[type];
    },
    // 获取奖品信息
    getRewards(id, awardId) {
      return queryActivityDetail({
        activityId: this.activityId,
        // activityId: 82,
      }).then((res) => {
        if (res.code != 0) {
          return;
        }
        const data = res.data || {};
        // 背景图片
        const bgUrl = data.backgroundPicUrl || "";
        this.bg = bgUrl;
        if (!this.bgm.length) {
          //如果已经有值了，就不要再次赋值
          this.bgm =
            JSON.parse(data.bgMusicFileUrl).map((item) => item.url) || "";
        }
        this.isLoop = data.bgMusicPlayType;
        // console.log();
        // 奖品
        this.awardList = data.awards;
        const rewardsArr = data.awards || [];
        const rewards = rewardsArr.find((item) => item.id == awardId);
        const winners = data.winners || [];
        this.isAldready = winners.length > 0;
        const {
          awardCount = 0,
          awardName = "",
          awardPicUrl = "",
          isLottery,
          awardAliasName,
          userGroup,
        } = rewards || {};
        this.unWinParticipants =
          data.unWinParticipants.filter((i) => i.userGroup == userGroup) || [];
        this.rewardsInfo = {
          //awardCount
          name: awardName,
          number: awardCount,
          img: awardPicUrl,
          isLottery,
          awardAliasName,
        };
        document.title = awardAliasName;
        // this.isLottery = 0
        this.isLottery = isLottery;
        console.log("3333333",isLottery);
        // 抽奖人名单
        const users =
          data.unWinParticipants.filter((i) => i.userGroup == userGroup) || [];
        if (Array.isArray(users) && users.length > 0) {
          const targetArr = users.map((item) => {
            return {
              name: item.userName,
              number: item.userWorkId,
              CompleteID: item.id,
              Award: "0",
            };
          });
          this.userData = targetArr || [];
        }
      });
    },
    // 上传到后端已经中奖的人
    uploadHaveAward(userIds) {
      const query = this.$route.query;
      if (query) {
        const params = {
          awardId: this.awardId,
          participantIds: userIds,
          awardCount: this.peopleNum,
        };
        this.isEnding = true;
        // if (this.isLottery) {
        //   params.awardCount = this.peopleNum;
        // }
        qryRewardPerson(params).then((res) => {
          if (res.code != 0) {
            alert(res.msg);
            this.isBegin = false;
            this.controlNum += 1;
            return;
          }
          this.userData = [];
          this.oneMorea = false;
          const query = this.$route.query;
          this.controlNum += 1;
          this.isLottery = 1;
          this.isBegin = false;
          if (query) {
            const { activityId, awardId } = this;
            queryActivityDetail({
              activityId: activityId,
            }).then((res) => {
              if (res.code != 0) {
                return;
              }
              this.isEnding = false;
              const data = res.data || {};
              this.awardList = data.awards;
              const rewardsArr = data.awards || [];
              const rewards = rewardsArr.find((item) => item.id == awardId);
              const { userGroup } = rewards || {};
              this.unWinParticipants =
                data.unWinParticipants.filter(
                  (i) => i.userGroup == userGroup
                ) || [];
              // 抽奖人名单
              const users = this.unWinParticipants || [];
              if (Array.isArray(users) && users.length > 0) {
                const targetArr = users.map((item) => {
                  return {
                    name: item.userName,
                    number: item.userWorkId,
                    CompleteID: item.id,
                    Award: "0",
                  };
                });
                this.userData = targetArr || [];
              }
              //   console.log(users, "奖品");
            });
          }
          //   this.isBegin = false;
        });
      }
    },
    // 获得随机抽奖数
    getRand() {
      return Math.floor(Math.random() * this.userData.length);
    },
    // 去除已抽取观众
    findDelHasPersonInArr(arr, obj) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]["CompleteID"] === obj.CompleteID) {
          return true;
        }
      }
      return false;
    },
    // 开始抽奖
    async onStart() {
      const query = this.$route.query;
      if (this.isBegin) {
        return;
      }
      // await this.getDetail();
      // 定时器滚动 开始抽奖过程
      this.isBegin = true;
      this.isShowEmpty = false;
      if (query) {
        // 抽奖人名单
          const users = this.unWinParticipants || [];
          if (Array.isArray(users) && users.length > 0) {
            const targetArr = users.map((item) => {
              return {
                name: item.userName,
                number: item.userWorkId,
                CompleteID: item.id,
                Award: "0",
              };
            });
            this.userData = targetArr || [];
          }
      }
      this.timeInterJS = setInterval(this.rollList, this.intervalTime);
    },
    async getDetail(){
        const query = this.$route.query;
        if (query) {
        const { activityId, awardId } = this;
        await queryActivityDetail({
          activityId: activityId,
        }).then((res) => {
          if (res.code != 0) {
            return;
          }
          const data = res.data || {};
          const rewardsArr = data.awards || [];
          const rewards = rewardsArr.find((item) => item.id == awardId);
          const { userGroup } = rewards || {};
          this.unWinParticipants =
            data.unWinParticipants.filter((i) => i.userGroup == userGroup) ||
            [];
          // 抽奖人名单
          const users = this.unWinParticipants || [];
          if (Array.isArray(users) && users.length > 0) {
            const targetArr = users.map((item) => {
              return {
                name: item.userName,
                number: item.userWorkId,
                CompleteID: item.id,
                Award: "0",
              };
            });
            this.userData = targetArr || [];
          }
        });
      }
    },
    // 抽奖滚动函数
    rollList() {
      this.rollIdArr = [];
      //   console.log("this.userDatathis.userDatathis.userData", this.userData);
      let num =
        this.isLottery == 1
          ? Number(this.peopleNum)
          : this.rewardsInfo.number + Number(this.peopleNum);
      while (this.rollIdArr.length < num) {
        const rnd = this.getRand();
        const obj = this.userData[rnd];
        if (
          obj?.Award == "0" &&
          !this.findDelHasPersonInArr(this.rollIdArr, obj)
        ) {
          this.rollIdArr.push(obj);
        }
      }
    },
    // 暂停抽奖
    onPuse() {
      if (this.isBegin) {
        this.finished=false
        this.renderResult();
        // this.isForb = false
        setTimeout(() => {
          this.isForb = true;
        }, 400);
      }
    },
    // 抽取结果
    renderResult() {
      clearInterval(this.timeInterJS);
      const userIds = this.rollIdArr.map((item) => item.CompleteID);
      if (userIds.length > 15) {
        this.disabledChange = true
        this.startScrolling();
      }
      this.uploadHaveAward(userIds);
    },
    // 单独再抽一个
    oneAgain: debounce(function () {
      if (this.userData && this.userData.length == 0) {
        alert("参加抽奖的人员已经被抽完；请重新建立相关抽奖活动");
        return;
      }
      this.oneMorea = true;
      this.oneMore = true;
      this.timeInterJS = setInterval(this.oneAgainList, this.intervalTime);
    }, 300),
    oneAgainList() {
      this.rollIdArr = [];
      if (this.rollIdArr.length == 0) {
        const rnd = this.getRand();
        const obj = this.userData[rnd];
        if (
          obj?.Award == "0" &&
          !this.findDelHasPersonInArr(this.rollIdArr, obj)
        ) {
          this.rollIdArr.push(obj);
        }
      }
    },
    oneAgainPuse: debounce(function () {
      if (this.oneMore) {
        clearInterval(this.timeInterJS);
        const userIds = this.rollIdArr.map((item) => item.CompleteID);
        this.uploadHaveAward(userIds);
      }
    }, 400),
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  height: 100vh;
  background-size: 100% 100% !important;
  overflow: hidden;
}
.luckMain {
  transform-origin: 0 0;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1280PX;
  height: 720PX;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  image-rendering: -webkit-optimize-contrast !important;
  //   position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;

  .container {
    width: 100%;
    height: calc(100% - 195PX);
    // padding-bottom: 89PX;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 40PX;
  }
  .content {
    width: 100%;
    height: auto;
    margin-top: 28PX;
    // overflow: hidden;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    align-items: flex-start;
    .rewardsOrder {
      //   margin-top: 12PX;
      position: relative;
      width: 520PX;
      height: 400PX;
      background: linear-gradient(180deg, #fff0d9, #ffdfba 100%);
      border-radius: 10PX;
      display: flex;
      align-items: center;
      justify-content: center;
      .draw-title {
        position: absolute;
        top: -25PX;
        left: 50%;
        margin-left: -151PX;
        width: 302.5PX;
        height: 50PX;
        background-image: url("https://m.elongstatic.com/year-wish/newTitleBg.png");
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20PX;
        line-height: 20PX;
        color: #fff3df;
        font-weight: 550;
        z-index: 100;
      }
    }
  }
}
//当屏幕最小宽度为992PX
// @media screen and (max-width: 500PX) {
//   .luckMain {
//     background: url("http://m.elongstatic.com/year-wish/mobile-bg@2x.png");
//     background-size: 100% 100%;
//     background-repeat: no-repeat;
//     // height: 100vh;
//   }
//   .pc-wrap {
//     display: none;
//   }
// }
.people-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 450PX;
  height: 85%;
  margin-top: 16PX;
  //   background-color: #eb9696;
  //   gap: 0 12PX;
  padding: 6PX;
  overflow-y: auto;
  .people-item {
    height: 16.5%;
    width: calc(33% - 12PX);
    background-color: #fff;
    border-radius: 10PX;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 6PX;
    .people-name,
    .people-code {
      padding: 0 6PX;
      font-size: 16PX;
      font-family: PingFang TC, PingFang TC-500;
      font-weight: 550;
      text-align: center;
      color: #980f16;
      //   margin-bottom: 6PX;
    }
    .people-code {
      font-size: 12PX;
      margin-bottom: 0PX;
      font-weight: 500;
    }
  }
  .empty-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .empty-src {
    // opacity: 0.5;
    width: 120PX;
    height: 120PX;
  }
}
.hidden-volume-box {
  width: 240PX;
  height: 80PX;
  background: #fff;
  border-radius: 100PX;
  display: flex;
  align-items: center;
  padding-left: 16PX;
  justify-content: flex-start;
  position: fixed;
  right: -210PX;
  bottom: 200PX;
  z-index: 100;
  cursor: pointer;
  transition: transform 0.3s ease;
  img {
    width: 25PX;
    height: 25PX;
    // margin-right: 8PX;
  }
  .volume-box .el-slider__runway .el-slider__bar {
    background-color: rgb(13, 253, 0) !important;
  }
}
.volume-box {
  width: 240PX;
  height: 80PX;
  background: #ffffff;
  border-radius: 100PX;
  display: flex;
  align-items: center;
  padding-left: 16PX;
  justify-content: flex-start;
  position: fixed;
  right: 0PX;
  bottom: 200PX;
  z-index: 100;
  cursor: pointer;
  transition: transform 0.3s ease;
  img {
    width: 25PX;
    height: 25PX;
    margin-right: 20PX;
  }
  .volume-box .el-slider__runway .el-slider__bar {
    background-color: rgb(253, 129, 0) !important;
  }
}
::v-deep .el-slider__button-wrapper {
  display: flex;
  align-items: center;
}
.main-title {
  width: 500PX;
  display: block;
  margin: 0 auto;
  margin-top: 38PX;
}
.action-title {
  margin-top: 12PX;
  font-size: 25PX;
  font-weight: 550;
  color: #980f16;
  background: linear-gradient(109deg, #f6d294 0%, #fae5b8 100%);
  border: 1PX solid #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 260PX;
  height: 64PX;
  cursor: pointer;
  z-index: 100;
  border-radius: 50PX;
  box-shadow: 0PX 5PX 5PX 0PX rgba(0, 0, 0, 0.25);
  // margin-bottom: 32PX;
}
.draw-text{
    font-weight: 600;
    color: #666;
    font-size: 20PX;
}
</style>
